import { sendToApi } from 'api/client'
import { SuggestionRequest } from 'types'
import { RevisionAction, RevisionLevel, RevisionType } from '../Types'
import { VisualCompletionType } from 'api/clients/AiClient'

export interface RevisionPrompt {
  revisionType?: RevisionType
  customPrompt?: string
  action?: RevisionAction
  revisionLevel?: RevisionLevel
  tones?: string[]
  seoWords?: string[]
  brandVoiceId?: number
  image?: string
  completionTypes?: VisualCompletionType[]
  referenceText?: string
  language?: string
}

export type RevisionSelection = { [key: string]: any }

export interface RevisionRequestProps {
  articleId?: string
  layerId?: string
  designId?: string
  prompt: RevisionPrompt
  selection?: RevisionSelection
}

export const createRevisionRequest = ({
  articleId,
  layerId,
  prompt: {
    revisionType: revision_type,
    customPrompt: custom_prompt,
    action,
    revisionLevel: revision_level,
    tones: tone = [],
    seoWords: seo_words = [],
    brandVoiceId: brand_voice_id,
    image,
    completionTypes: completion_types,
    referenceText: reference_text,
  },
  selection,
}: RevisionRequestProps) => {
  return sendToApi<{
    request: SuggestionRequest
  }>(`/articles/${articleId}/ai_suggestion_requests/revisions`, {
    method: 'POST',
    body: {
      prompt: {
        revision_type,
        custom_prompt,
        action,
        revision_level,
        tone,
        seo_words,
        brand_voice_id,
        image,
        completion_types,
        reference_text,
      },
      layer_id: layerId,
      selection,
    },
  })
}
